import { options } from './getAreShipmentsAvailable';
import { getResourceStale } from '~shared/selectors/getResource';

const getAreShipmentsStale = getResourceStale(options);

export default getAreShipmentsStale;
